import * as React from "react";
const ElchemyLogoSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={143}
    height={48}
    fill="none"
    {...props}
  >
    <path
      fill="#040919"
      d="M8.421 19.938v6.408h11.987v4.434H3.205V4.7h16.833v4.434H8.42v6.37h11.063v4.433H8.42ZM49.787 25.976c-1.332 3.092-4.107 5.178-8.362 5.178-6.141 0-9.212-3.875-9.212-9.686 0-5.812 3.07-9.687 9.212-9.687 3.959 0 6.697 1.826 8.102 4.47l-4.513 2.72c-.888-1.825-2.22-2.757-3.589-2.757-2.7 0-3.995 2.05-3.995 5.253 0 3.204 1.294 5.253 3.995 5.253 1.406 0 2.886-.97 3.626-2.869l4.736 2.125ZM57.482 30.78h-5.216V3.584h5.216v10.32c1.406-1.454 2.96-2.124 5.142-2.124 3.7 0 5.883 2.273 5.883 7.041V30.78h-5.216V18.933c0-1.9-1.036-2.72-2.59-2.72-1.924 0-3.219 1.64-3.219 5.85v8.717ZM29.332 22.063v8.717h-5.217V3.584h5.217v18.479ZM88.792 29.326c-2.553 1.23-5.032 1.826-7.326 1.826-6.29 0-10.173-3.688-10.173-9.686 0-5.812 3.108-9.687 9.212-9.687 5.771 0 8.62 3.726 8.62 8.867v2.757H76.694c.519 2.086 2.035 3.316 4.883 3.316 1.555 0 3.404-.485 5.55-1.528l1.665 4.135ZM76.805 19.12h7.066c-.148-2.012-1.517-2.906-3.367-2.906-1.96 0-3.181 1.08-3.7 2.906ZM106.399 14.734c1.295-1.9 3.33-2.905 5.623-2.905 3.996 0 6.808 2.16 6.808 6.631v12.37h-5.217V18.384c0-1.49-1.184-2.124-2.182-2.124-2.183 0-3.293 1.714-3.293 4.768v9.799h-5.216v-12.22c0-1.602-1.147-2.347-2.331-2.347-1.85 0-3.144 1.715-3.144 4.807v9.76H92.23V12.201h5.216v1.863c.999-1.527 2.22-2.236 4.031-2.236 2.184 0 3.996 1.043 4.921 2.906ZM132.743 29.107l-6.957 16.169h-5.624l6.659-16.423-6.659-16.654h5.661l6.92 16.908Z"
    />
    <path
      fill="url(#a)"
      d="m130.314 23.116 4.024-10.917h5.586l-4.669 10.924-4.941-.007Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={130.314}
        x2={139.924}
        y1={17.661}
        y2={17.661}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F15B2A" />
        <stop offset={1} stopColor="#EF4137" />
      </linearGradient>
    </defs>
  </svg>
);
export default ElchemyLogoSVG;
